import React from 'react';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { MichelinLogo, usePhoneView } from '@michelin/acid-components';
import { LogoPoweredBySVGDarkFrench } from '../../images/logos/LogoPoweredBySVGDarkFrench';
import { LogoPoweredBySVGFrench } from '../../images/logos/LogoPoweredBySVGFrench';
import { LogoPoweredBySVGDark } from '../../images/logos/LogoPoweredBySVGDark';
import { LogoPoweredBySVG } from '../../images/logos/LogoPoweredBySVG';
import { LogoBlueBackgroundPoweredBySVG } from '../../images/logos/LogoBlueBackgroundPoweredBySVG';
import { LogoDarkSVG } from '../../images/logos/LogoDarkSVG';
import { LogoSVG } from '../../images/logos/LogoSVG';
var styles = function () { return createStyles({
    logo: {
        marginTop: '0',
        marginBottom: '0',
        paddingTop: '0',
    },
}); };
export var Logo = withStyles(styles)(function (props) {
    var logoType = props.logoType, darkMode = props.darkMode, lang = props.lang;
    var phoneView = usePhoneView();
    var logoWidth = phoneView ? '35vw' : '13vw';
    switch (logoType) {
        case 'michelin':
            return React.createElement(MichelinLogo, { direction: "stacked", style: { height: 63, marginTop: 6 } });
        case 'poweredByMichelin':
            if (lang && lang === 'fr_CA')
                return (darkMode) ? LogoPoweredBySVGDarkFrench(logoWidth) : LogoPoweredBySVGFrench(logoWidth);
            return (darkMode) ? LogoPoweredBySVGDark(logoWidth) : LogoPoweredBySVG(logoWidth);
        case 'blueBackgroundPoweredByMichelin':
            return LogoBlueBackgroundPoweredBySVG(63); // Using height, not width, here to match MichelinLogo
        case 'maestroLogo':
        default:
            return (darkMode) ? LogoDarkSVG : LogoSVG;
    }
});
//# sourceMappingURL=Logo.js.map